export default "__VITE_PUBLIC_ASSET__180ea532__"